import { action, CubePresenter, FlipIntent, Logger, Presenter } from 'wdc-cube'

import { WaitingScope } from 'src/components/waiting/waiting.scopes'
import { MainPresenter } from 'src/main/Main.presenter'
import AnaliseKeys from './analise.keys'
import AnaliseScope, { HeaderScope } from './analise.scopes'
import analiseService from './analise.service'
import { AnaliseFormKeys } from './form'

const LOG = Logger.get('AnalisePresenter')

export class AnalisePresenter extends CubePresenter<MainPresenter, AnaliseScope> {
    // :: Fields

    private readonly __headerBar: Presenter<HeaderScope, AnalisePresenter>

    // :: Constructor

    public constructor(app: MainPresenter) {
        super(app, new AnaliseScope())
        this.__headerBar = new Presenter(this, this.scope.header)
    }

    // :: Methods

    public override release() {
        this.app.releaseToolbar(this.__headerBar)
        super.release()
        LOG.debug('Finalized')
    }

    public override async applyParameters(intent: FlipIntent, initialization: boolean): Promise<boolean> {
        const keys = new AnaliseKeys(this.app, intent)

        this.app.scope.toolbar = this.__headerBar.scope

        keys.parentSlot(this.scope)

        if (initialization) {
            await this.#initialize()
        }

        if (!this.scope.analises || this.scope.analises.length === 0) {
            await this.handleFind()
        }

        if (keys.analiseId !== this.scope.idSelected) {
            this.scope.idSelected = keys.analiseId ?? 0
        }

        return keys.allow
    }

    public override publishParameters(intent: FlipIntent): void {
        const keys = new AnaliseKeys(this.app, intent)
        keys.analiseId = this.scope.idSelected
    }

    async #initialize() {
        LOG.debug('initialize')
        this.scope.onFind = this.handleFind.bind(this)
        this.scope.onNew = this.handleNew.bind(this)
        this.scope.onEdit = this.handleEdit.bind(this)
        this.scope.onDelete = this.handleDelete.bind(this)
    }

    async handleEditAnalise(analiseId: number) {
        const target = new AnaliseFormKeys(this.app)
        target.analiseId = analiseId
        await target.flip()
    }

    @action()
    private async handleFind() {
        try {
            this.scope.waiting = new WaitingScope()
            const analises = await analiseService.fetchAnalises(this.scope.nomeAnaliseInputRef)
            this.scope.analises = analises
        } catch (caught) {
            LOG.error('handleFind', caught)
            throw caught
        } finally {
            this.scope.waiting = undefined
        }
    }

    @action()
    private async handleNew() {
        const target = new AnaliseFormKeys(this.app)
        await target.flip()
    }

    @action()
    private async handleEdit() {
        const target = new AnaliseFormKeys(this.app)
        target.analiseId = this.scope.idSelected
        await target.flip()
    }

    @action()
    private async handleDelete() {
        try {
            if (!this.scope.idSelected) {
                throw new Error('Análise deve ser selecionado')
            }
            const idRemover = this.scope.idSelected
            if (!confirm('Confirma a exclusão da análise?')) {
                return
            }
            const deleted = await analiseService.deleteAnalise(idRemover)
            if (!deleted) return
            this.scope.analises = this.scope.analises.filter((r) => r.id !== idRemover)
            this.app.notify('success', 'Removido com sucesso')
        } catch (caught) {
            LOG.error('handleDelete', caught)
            throw caught
        }
    }
}

export default AnalisePresenter
